var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 282,
    viewBox: "0 0 1920 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.35 65.9861C1085.71 -122.168 -16 152.941 -16 152.941V258.525H1976C1976 46.267 1326.95 106.2 1326.95 106.2L1348.35 65.9861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.35 71.9861C1076.71 -116.168 -25 158.941 -25 158.941V264.525H1967C1967 52.267 1317.95 112.2 1317.95 112.2L1339.35 71.9861Z",
    fill: "#2173BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.35 80.9861C1061.71 -107.168 -40 167.941 -40 167.941V273.525H1952C1952 61.267 1302.95 121.2 1302.95 121.2L1324.35 80.9861Z",
    fill: "#DA1F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.35 88.9861C1045.71 -99.1675 -56 175.941 -56 175.941V281.525H1936C1936 69.267 1286.95 129.2 1286.95 129.2L1308.35 88.9861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 281,
    fill: "white",
    transform: "translate(0 0.17627)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer1.2ebc7001a14c217305d8a4f9a7f00d91.svg";
export { ForwardRef as ReactComponent };